var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-item-box",on:{"click":function($event){return _vm.$emit('click')},"mouseenter":function($event){_vm.showHover=true},"mouseleave":function($event){_vm.showHover=false}}},[_c('img',{staticClass:"pic",attrs:{"src":_vm.img}}),(_vm.showHover)?_c('div',{staticClass:"hover_container"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }